import { Component, OnInit, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService } from 'primeng/api';
import { ArrivalsBoardService } from '../arrivals-board.service';
import { AlertService, ConstantService } from '@app/_services';

@Component({
    selector: 'app-arrivals-sms-dialog',
    templateUrl: './arrivals-sms-dialog.component.html',
    styleUrls: ['./arrivals-sms-dialog.component.scss'],
    providers: [MessageService],
    standalone: false
})
export class ArrivalsSmsDialogComponent implements OnInit {

    /** Emits the formatted sent time (e.g. "2:34 PM") on successful send. */
    @Output() smsSent = new EventEmitter<string | null>();

    reservation: any;
    countries: any[];
    form1: UntypedFormGroup;
    formLoading = false;
    formTitle: string;

    validationMessages = {
        toMobileCtry: [],
        toMobile: [{ type: 'required', message: 'Required' }],
        smsMessage: [{ type: 'required', message: 'Required' }]
    };

    constructor(
        private fb: UntypedFormBuilder,
        private arrivalsBoardService: ArrivalsBoardService,
        private alertService: AlertService,
        private messageService: MessageService,
        private constantService: ConstantService,
        @Inject(MAT_DIALOG_DATA) data: any
    ) {
        this.formTitle = data.title || 'Send Arrival SMS';
        this.reservation = data.reservation;
        this.countries = this.constantService.countries;
    }

    ngOnInit(): void {
        this.buildForm();
        this.form1.patchValue({
            toMobile: this.reservation?.mobilePhone || '',
            smsMessage: this.buildDefaultMessage()
        });
    }

    buildForm(): void {
        this.form1 = this.fb.group({
            toMobileCtry: ['+1'],
            toMobile: ['', Validators.required],
            smsMessage: ['', Validators.required],
            sendBySms: [true]
        });
    }

    /**
     * Build a pre-filled arrival message using available reservation data.
     * The operator can edit before sending.
     */
    buildDefaultMessage(): string {
        const firstName = this.reservation?.guestFirstName || 'Guest';
        const propertyCode = this.reservation?.propertyCode || '';
        const doorCode = this.reservation?.accessCodeFrontDoor || '[DOOR CODE]';
        return `Aloha ${firstName}! Your unit ${propertyCode} is ready. Door code: ${doorCode}. Please let us know if you need anything. Mahalo, KBM Hawaii`;
    }

    send(): void {
        this.form1.markAllAsTouched();
        if (this.form1.invalid) return;

        this.formLoading = true;

        const payload = {
            ...this.form1.value,
            reservationId: this.reservation?.reservationId || null,
            guestFirstName: this.reservation?.guestFirstName || null
        };

        this.arrivalsBoardService.sendArrivalSms(payload).subscribe({
            next: (res: any) => {
                this.formLoading = false;
                this.messageService.add({ severity: 'success', summary: 'SMS Sent', detail: res?.message || 'Message sent successfully.' });
                // Emit current time as the sentAt label for the parent to display
                const now = new Date();
                const hours = now.getHours() % 12 || 12;
                const minutes = String(now.getMinutes()).padStart(2, '0');
                const ampm = now.getHours() >= 12 ? 'PM' : 'AM';
                const sentAt = `${hours}:${minutes} ${ampm}`;
                this.smsSent.emit(sentAt);
            },
            error: (err: any) => {
                // Do NOT reset formLoading on error — a 504 means the SMS may have been sent.
                // Keep button disabled to prevent a duplicate SMS from being triggered.
                this.alertService.error('SMS send failed. Please refresh before retrying: ' + (err?.statusText || 'Unknown error'));
            }
        });
    }
}
